import AttorneyShell from "@/components/AttorneyShell";
import { Integrations } from "@/components/IntegrationCenter";

export default function IntegrationsPage() {
  return <AttorneyShell><Integrations /></AttorneyShell>;
}
